<div class="card-container">
  <div class="card-subcontainer">
    <mat-card class="home-card">
      <mat-card-header>
        <mat-card-title>{{'home.text.title' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'home.text.subtitle' | translate}}</mat-card-subtitle>
      </mat-card-header>
      <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
      <mat-card-content>
        
      </mat-card-content>
      <mat-card-actions style="text-align: center;">
        <button (click)="openText()" matTooltip="Reconocer textos" mat-raised-button>
          <mat-icon>textsms</mat-icon> {{'home.text.button' | translate}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="card-subcontainer">
    <mat-card class="home-card">
      <mat-card-header>
        <mat-card-title>{{'home.image.title' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'home.image.subtitle' | translate}}</mat-card-subtitle>
      </mat-card-header>
      <!-- <img mat-card-image height="100px" src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
      <mat-card-content>
        
      </mat-card-content>
      <mat-card-actions style="text-align: center;">
        <button (click)="openImage()" matTooltip="Reconocer imágenes" mat-raised-button>
          <mat-icon>image</mat-icon> {{'home.image.button' | translate}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="card-subcontainer">
    <mat-card class="home-card">
      <mat-card-header>
        <mat-card-title>{{'home.numerical.title' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'home.numerical.subtitle' | translate}}</mat-card-subtitle>
      </mat-card-header>
      <!-- <img mat-card-image height="100px" src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
      <mat-card-content>
        
      </mat-card-content>
      <mat-card-actions style="text-align: center;">
        <button (click)="openNumerical()" matTooltip="Reconocer números" mat-raised-button>
          <mat-icon>table_chart</mat-icon> {{'home.numerical.button' | translate}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>